"use client";
import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalTrigger,
} from "@/components/ui/Modal/AnimatedModal";
import Link from "next/link";

export function ContactModal() {
  const images = [
    "/images/profiles/1.jpg",
    "/images/profiles/2.jpg",
    "/images/profiles/3.jpg",
    "/images/profiles/5.jpg",
    "/images/profiles/4.jpg",
  ];

  const socials = [
    {
      icon: "/icons/socials/github.svg",
      title: "Github",
      url: "https://github.com/kansoul",
    },
    {
      icon: "/icons/socials/linkedin.svg",
      title: "LinkedIn",
      url: "https://linkedin.com/in/kansoul/",
    },
    {
      icon: "/icons/socials/twitter.svg",
      title: "Twitter",
      url: "https://twitter.com/kansoul",
    },
    {
      icon: "/icons/socials/facebook.svg",
      title: "Facebook",
      url: "https://facebook.com/kansoul",
    },
  ];

  return (
    <div className="mt-10 lg:mt-4 flex items-center justify-center">
      <Modal>
        <ModalTrigger className="download-my-cv dark:bg-[#3b3b3b] dark:hover:bg-[#646464]">
          <div>
            <div className="pencil"></div>
            <div className="folder">
              <div className="top">
                <svg viewBox="0 0 24 27">
                  <path d="M1,0 L23,0 C23.5522847,-1.01453063e-16 24,0.44771525 24,1 L24,8.17157288 C24,8.70200585 23.7892863,9.21071368 23.4142136,9.58578644 L20.5857864,12.4142136 C20.2107137,12.7892863 20,13.2979941 20,13.8284271 L20,26 C20,26.5522847 19.5522847,27 19,27 L1,27 C0.44771525,27 6.76353751e-17,26.5522847 0,26 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 Z"></path>
                </svg>
              </div>
              <div className="paper"></div>
            </div>
          </div>
          CV của mình
        </ModalTrigger>
        <ModalBody>
          <ModalContent>
            <h4 className="text-lg md:text-2xl text-neutral-600 dark:text-neutral-100 font-bold text-center mb-8">
              Liên hệ với{" "}
              <span className="px-1 py-0.5 rounded-md bg-gray-100 dark:bg-neutral-800 dark:border-neutral-700 border border-gray-200">
                Đoan
              </span>{" "}
              ngay nào! 💻
            </h4>
            <div className="flex justify-center items-center">
              {images.map((image, idx) => (
                <motion.div
                  key={"images" + idx}
                  style={{
                    rotate: Math.random() * 20 - 10,
                  }}
                  whileHover={{
                    scale: 1.1,
                    rotate: 0,
                    zIndex: 100,
                  }}
                  whileTap={{
                    scale: 1.1,
                    rotate: 0,
                    zIndex: 100,
                  }}
                  className="rounded-xl -mr-4 mt-4 p-1 bg-white dark:bg-neutral-800 dark:border-neutral-700 border border-neutral-100 flex-shrink-0 overflow-hidden"
                >
                  <Image
                    src={image}
                    alt="bali images"
                    width="500"
                    height="500"
                    className="rounded-lg h-20 w-20 md:h-40 md:w-40 object-cover flex-shrink-0"
                  />
                </motion.div>
              ))}
            </div>
            <div className="py-10 flex flex-wrap gap-y-6 items-start justify-start max-w-sm mx-auto">
              {socials.map((social) => (
                <Link
                  href={social.url}
                  key={social.title}
                  target="_blank"
                  className="flex items-center w-1/2 gap-4 justify-center"
                >
                  <Image
                    alt={social.title}
                    src={social.icon}
                    width={24}
                    height={24}
                    className="bg-white"
                  />
                  <p className="text-sm text-gray-700 dark:text-white">
                    {social.title}
                  </p>
                </Link>
              ))}
            </div>
          </ModalContent>
          <ModalFooter className="gap-4">
            <button className="px-2 py-1 bg-gray-200 text-black dark:bg-black dark:border-black dark:text-white border border-gray-300 rounded-md text-sm w-28">
              Huỷ
            </button>
            <button className="bg-black text-white dark:bg-white dark:text-black text-sm px-2 py-1 rounded-md border border-black w-36">
              CV của mình
            </button>
          </ModalFooter>
        </ModalBody>
      </Modal>
    </div>
  );
}
